export default __webpack_public_path__ + "static/media/ExportGOOD_ServiceAsiaT10CV.e274d01c.svg";